<template>
    <div class="w-100">
        <my-form ref="form">
            <v-row v-if="definedShippments">
                <div class="w-100">
                    <v-row class="mx-0" wrap v-if="false">
                        <v-col cols="12" class="mb-0">
                            <p class="mb-0"></p>
                        </v-col>
                        <v-col sm="12" md="4" v-for="shipping in definedShippments">
                            <v-card :loading="load" style="width: 100%">
                                <v-img height="150px" width="300px" :src="$root.getSrc(shipping.icon)">
                                    <div class="pa-2">
                                        <v-btn @click="toggleShippment(shipping)" fab color="primary"><v-icon color="white">mdi-plus</v-icon></v-btn>
                                    </div>
                                </v-img>
                                <v-card-text>
                                    <h3>{{shipping.name}}</h3>
                                    <p class="mb-1">{{$t('Price')}}: {{shipping.price}}</p>
                                    <p class="mb-1">{{$t('Max weight')}}: {{shipping.max_weight}}Kg</p>
                                    <p class="mb-1">{{$t('Abroat')}}?: <v-chip small color="success" v-if="shipping.abroat">Yes</v-chip> <v-chip small v-else color="red">No</v-chip></p>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row class="mx-0" wrap>
                        <v-col cols="12" class="mb-0">
                            <p class="mb-0 input-label-styling">{{$t('Twoje wysyłki w sklepie')}}:</p>
                        </v-col>
                        <v-col cols="12" class="grey--text" v-if="!shippments || shippments.length == 0">{{$t('Brak elementów')}}</v-col>
                        <v-col sm="12" md="6" v-for="(shipping,id) in shippments.filter(ship=>ship.international==0)">
                            <div>
                                <v-card :loading="load" style="width: 100%">
                                    <v-img height="150px" width="300px" :src="$root.getSrc(shipping.icon)"></v-img>
                                    <v-card-text v-if="shipping.shipping">
                                        <p class="input-label-styling">{{$t('Carrier')}}: {{shipping.name}}</p>
                                        <p class="input-label-styling" v-if="totalShippingPrice(shipping)">{{$t('Total shippment price (Your margin + Original shippment price)')}} {{totalShippingPrice(shipping)| currency()}}</p>
                                        <v-text-field outlined min="0" :rules="[validationRules.maxShippingPrice(shipping.price,2)]" type="number" v-model="shipping.price"  :label="$t('Shipping margin')"></v-text-field>
                                        <p class="input-label-styling">{{$t('Max shippment weight')}} (KG): {{shipping.max_weight}}</p>
                                        <v-switch v-model="shipping.abroat" :label="$t('Abroat')"></v-switch>
                                    </v-card-text>
                                    <v-card-actions>
                                        <!--<v-btn color="red" :loading="load" @click="shippments.splice(id, 1)" class="white&#45;&#45;text">{{$t('Delete')}}</v-btn>-->
                                    </v-card-actions>
                                </v-card>
                            </div>
                        </v-col>
<!--                        <v-col v-if="shipping.international==1" sm="12" md="6" v-for="(shipping,id) in shippments">-->
<!--                            <div>-->
<!--                                <v-card :loading="load" style="width: 100%">-->
<!--                                    <v-card-text>-->
<!--                                        <v-text-field outlined :rules="[validationRules.required]" v-model="shipping.name" :label="$t('Carrier')">{{shipping.name}}</v-text-field>-->
<!--                                        <v-text-field outlined min="0" :rules="[validationRules.price(shipping.international_price)]" type="number" v-model="shipping.international_price"  :label="$t('Shipping price')"></v-text-field>-->
<!--                                        <v-text-field outlined min="0" :rules="[validationRules.price(shipping.price)]" type="number" v-model="shipping.price"  :label="$t('Shipping margin')"></v-text-field>-->
<!--                                        <v-text-field outlined min="0" :rules="[validationRules.required]" type="number" v-model="shipping.max_weight"  :label="$t('Max shippment weight (KG)')">{{shipping.max_weight}}</v-text-field>-->
<!--                                    </v-card-text>-->
<!--                                    <v-card-actions>-->
<!--                                        <v-btn color="red" :loading="load" @click="shippments.splice(id, 1)" class="white&#45;&#45;text">{{$t('Delete')}}</v-btn>-->
<!--                                    </v-card-actions>-->
<!--                                </v-card>-->
<!--                            </div>-->
<!--                        </v-col>-->
                    </v-row>
<!--                    <v-card-actions>-->
<!--                        <v-spacer></v-spacer>-->
<!--                        <v-btn class="small-btns" @click="addInternationalShipping" dark color="secondary">Add international shipping</v-btn>-->
<!--                    </v-card-actions>-->
                </div>
            </v-row>
        </my-form>
    </div>
</template>
<script>
    import {getWebsites} from "../../api/websites";
    import {getShippments} from "../../api/shippments";
    import {saveShippments} from "../../api/shippments";
    import {getBreads} from "../../api/bread";

    export default {
        props:['website_id'],
        data: () => {
            return{
                load: false,
                shippments:[],
                rules:{
                    name:[
                        v => !!v || 'Name is required',
                    ],
                    price:[
                        v => (typeof v != 'number' || typeof v != 'string') || 'Price is required',
                        v => v >= 0 || 'Price must be greater than 0'
                    ]
                },
                definedShippments: null
            }
        },
        computed:{
            websites(){return this.$store.getters.websites},
            selectedWebsite(){
                if(!this.website_id){
                    return this.$store.getters.activeWebsite
                }else{
                    return this.$store.getters.websites.find(x => x.id == this.website_id);
                }
            }
        },
        watch:{
            shippments:{
                handler: function () {
                    this.$emit('input', this.shippments)
                },
                deep: true
            },
            selectedWebsite: function () {
                if(this.selectedWebsite){
                    this.getShippments();
                }
            }
        },
        mounted() {
            this.getAvailableShippments();
            this.getShippments();
        },
        methods:{
            totalShippingPrice(shipping){
                if(!shipping.shipping) return shipping.price;
                if(shipping.id) return parseFloat(shipping.price) + parseFloat(shipping.shipping.price);
                if(!shipping.shipping) return shipping.price;
                return parseFloat(shipping.price) + parseFloat(shipping.shipping.price);
            },
            getAvailableShippments(){
                let websiteId;
                this.$store.getters.websites.length>0 ? websiteId = 0 : websiteId = null;
                getBreads('Shipment', {model_name: 'Shop/Shipping', per_page:100000, website_id: websiteId}).then(response => {
                    this.definedShippments = response.data.filter(x => x.website_id == null);
                    if(!this.website_id){
                        this.toggleShippment(response.data.filter(x => x.name == 'USPS' && x.website_id == null && x.international==0)[0]);
                    }
                })
            },
            save(){
                if(this.$refs.form.my_validate()){
                    this.load = true;
                    saveShippments(this.selectedWebsite.id, {shippings: this.shippments}).then(response => {
                        this.load = false;
                    }).catch(e => {
                        this.$store.commit('app/ADD_MESSAGE', {text: this.$t('Nie udało się zaktualizować wysylek'), type: 'error'});
                    })
                }
            },
            toggleShippment(shippment){
                shippment.parent_id = shippment.id;
                shippment.shipping = Object.assign({}, shippment);
                shippment.price = 0;
                shippment.id = null;
                if(!shippment.website_id){
                    if(this.selectedWebsite) shippment.website_id = this.selectedWebsite.id;
                }
                if(this.shippments.find(x => x == shippment) == null){
                    this.shippments.push(Object.assign({}, shippment));
                }
            },
            getShippments(){
                getShippments(this.selectedWebsite.id).then(response => {
                    if(this.website_id && response.length > 0){
                        this.shippments = response;
                    }else{
                        this.toggleShippment(this.definedShippments.filter(x => x.name == 'USPS' && x.website_id == null)[0]);
                    }
                })
            },
            validateShippment(){
                return this.$refs.form.validate();
            },
            addInternationalShipping(){
                let internationalShipping = {
                    name: '',
                    price: 0,
                    abroat: 1,
                    max_weight: 0,
                    international: 1
                };
                this.shippments.push(internationalShipping);
            }
        }
    }


</script>
<style scoped>
.input-label-styling {
    font-size: 12px;
    font-weight: 600;
    color:#575A5E;
}
</style>
